import React from 'react';
import {connect} from 'react-redux';
import {connectWithCore} from 'framework/hocs';
import {DynamicMultiSelectField} from 'app-ui-componentlibrary/dist/componentLibrary/form/DynamicMultiSelectField'

export {DynamicMultiSelectField};
export const mapStateToProps = (state) => {
  return {
    dynamicComponent: state.dynamicComponent,
  };
};
export default connect(mapStateToProps)(connectWithCore(DynamicMultiSelectField));
